import { CANCEL_STRINGS_PATH } from "../../../services/orders/cancellation.types";
import { NewMessageBanner } from "../../stores/use-notification-store";
import { getString } from "../../uistringlabels/ui-string-utils";

export const CANCEL_SUCCESS_BANNER_MS = 5000;

export const createCancelServiceErrorBanner = (): NewMessageBanner => ({
  type: "error",
  message: getString(`${CANCEL_STRINGS_PATH}.errorMessage`),
  cti: true,
});

/** The legacy orders page keeps its original cancel error, with no ticket link. */
export const createLegacyCancelErrorBanner = (): NewMessageBanner => ({
  type: "error",
  message: getString(`${CANCEL_STRINGS_PATH}.legacyErrorMessage`),
});
